import { pages } from '@/navigation/vertical'
import i18n from '@/libs/i18n'

export default function getSearchIndex() {
  return {
    pages: {
      key: 'title',
      data: pages().filter(page => page.route && page.title).map(page => ({
        title: i18n.te(page.title) ? i18n.t(page.title) : page.title,
        route: { name: page.route },
        icon: page.icon || 'FileTextIcon',
        stepsNames: page.stepsNames ?? [],
      })),
    },
  }
}
